module.exports = __webpack_public_path__ + "img/top5.L.431c43c7.png";